import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Text } from '@chakra-ui/react';
export default function DescriptionField({ description, id }) {
    if (!description) {
        return null;
    }
    if (typeof description === 'string') {
        return (_jsx(Text, { as: 'sup', fontSize: 'md', id: id, children: description }));
    }
    return _jsx(_Fragment, { children: description });
}
//# sourceMappingURL=DescriptionField.js.map